import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Назначение курьера",
    overflow: false,
    loading: _ctx.loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_select, {
        value: _ctx.state.courier_id,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.courier_id) = $event)),
        placeholder: "Выберите курьера",
        options: _ctx.couriers_state.list,
        loading: _ctx.couriers_state.is_loading,
        failed: _ctx.couriers_state.is_failed,
        "error-text": "При получении списка курьеров произошла ошибка",
        label: "fullName",
        "search-without-refresh": "",
        "search-by": "fullName",
        disabled: _ctx.loading,
        "is-invalid": _ctx.validation$.courier_id.$error,
        "validation-errors": _ctx.validation$.courier_id.$errors
      }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onSubmit", "onCancel"]))
}